module.exports = __webpack_public_path__ + "static/img/culture1.1ddfe01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduce/culture1.png
// module id = iFzh
// module chunks = 1